import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.TwoFaEnablingWizard.AnotherMethodButton', {
    anotherMethodButton: 'Choose another backup method',
});
